export class Statspaiement {

      nombre: number;
      somme: number;

}

